export const environment = {
  production: false,
  apiUrl: "https://social.friendsoftheoriginalconstitution.org/api"
  // apiUrl: "http://localhost:3001/api"
}
